import { render } from "./LayoutMain.vue?vue&type=template&id=342b6790"
import script from "./LayoutMain.vue?vue&type=script&lang=js"
export * from "./LayoutMain.vue?vue&type=script&lang=js"
script.render = render

export default script